import { NgModule } from '@angular/core';
import { AngularDeviceInformationComponent } from './angular-device-information.component';



@NgModule({
  declarations: [AngularDeviceInformationComponent],
  imports: [
  ],
  exports: [AngularDeviceInformationComponent]
})
export class AngularDeviceInformationModule { }
